<template>
    <v-autocomplete
        dense
        outlined
        v-model="select"
        @input="HandleInput"
        :items="items"
        :search-input.sync="search"
        :item-text="DisplayName"
        :readonly="readonly"
        return-object
        :clearable="!readonly"
        no-filter
        flat
        hide-no-data
        hide-details
        :label="label || $t('Person')"
        @change="$emit('personChanged',select)"
    ></v-autocomplete>
</template>

<script>
import personService from '@/service/person-service';

export default {
    props: {
        value: Number,
        label: String,
        employee: Boolean,
        parentCode: Number,
        readonly: Boolean,
        branch: Number,
    },
    data() {
        return {
            items: [],
            search: null,
            select: null,
            timer: null,
            getDataAbort: null,
        };
    },
    mounted() {
        if (this.value) {
            this.SetSelected(this.value);
        }
    },
    watch: {
        search(value, oldValue) {
            if (value !== oldValue) {
                if (
                    value !== (this.select && this.select.code) &&
                    value !== this.DisplayName(this.select)
                ) {
                    clearTimeout(this.timer);
                    this.items = [];
                    if (this.getDataAbort) {
                        this.getDataAbort.abort();
                    }
                    if (value) {
                        this.timer = setTimeout(
                            () => this.QuerySelections(value),
                            300
                        );
                    }
                }
            }
        },
        value(val) {
            if (!val) {
                this.search = null;
                this.select = null;
                this.items = [];
            } else {
                this.SetSelected(val);
            }
        },
    },
    methods: {
        async GetData(filter, callback) {
            if (this.getDataAbort) {
                this.getDataAbort.abort();
                this.items = [];
            }
            this.getDataAbort = new AbortController();
            const parentCode = this.employee
                ? await personService.constant.parentCode.employee()
                : this.parentCode;
            personService
                .getData(
                    1,
                    20,
                    {
                        ...filter,
                        parent_code: parentCode || this.parentCode,
                        branch: this.branch || null,
                    },
                    this.getDataAbort && this.getDataAbort.signal
                )
                .then((response) => callback(response))
                .finally(() => {
                    this.getDataAbort = null;
                });
        },
        QuerySelections(search) {
            let filter = {};
            let fullnameRegex = /^([^ ]+) ([^ ]+)$/;
            if (/^\d+$/.test(search)) {
                filter.code = +search;
            } else if (/^-\d+$/.test(search)) {
                filter.tabel = -+search;
            } else if (fullnameRegex.test(search)) {
                let regexResult = fullnameRegex.exec(search);
                filter.lastname = regexResult[1];
                filter.firstname = regexResult[2];
            } else {
                filter.lastname = search;
            }
            this.GetData(filter, (response) => (this.items = response.data));
        },
        HandleInput() {
            this.$emit('input', this.select && this.select.code);
        },
        SetSelected(value) {
            if (value && value !== (this.select && this.select.code)) {
                this.GetData({ code: value }, (response) => {
                    var data = response.data.filter((d) => d.code == value);
                    if (data.length > 0) {
                        this.items = data;
                        this.select = data[0];
                    }
                });
            }
        },
        DisplayName(person) {
            if (person) {
                return `[${person.code}] ${person.lastname || ''} ${
                    person.firstname || ''
                }`;
            }
            return null;
        },
    },
};
</script>

<style>
</style>
